import { Router, UrlTree } from '@angular/router';

/** Only internal application paths are accepted as post-login redirects. */
export function safeReturnUrl(url: string | null | undefined): string | null {
  if (!url || !url.startsWith('/') || url.startsWith('//')) return null;

  const path = url.toLowerCase();
  if (path === '/login' || path.startsWith('/login?') || path.startsWith('/login#')) return null;

  return url;
}

/** Sends the user to the login page and remembers where to return after sign-in. */
export function loginUrlTree(router: Router, returnUrl: string | null | undefined): UrlTree {
  const safe = safeReturnUrl(returnUrl);
  return safe
    ? router.createUrlTree(['/login'], { queryParams: { returnUrl: safe } })
    : router.parseUrl('/login');
}
